import { FC } from 'react';

import { Icon } from '@pp/core/src/components/icons/icon';
import { Icons } from '@pp/core/src/components/icons/iconNames';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';
import { useAudioTrigger } from '@pp/core/src/controllers/audioController/hooks';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import styles from './PreviousRound.module.css';

interface PreviousRoundProps {
  show: boolean;
  setShow: (value: boolean) => void;
}

export const PreviousRound: FC<PreviousRoundProps> = ({ show, setShow }) => {
  const audioTrigger = useAudioTrigger();

  const mods = useModifiers(styles, 'previousRound', {
    close: !show,
  });

  const handlePreviousClick = () => {
    setShow(!show);
    audioTrigger.play({ name: 'menuClick' });
  };

  return (
    <div onClick={handlePreviousClick} className={`${styles.previousRound} ${mods}`}>
      <div className={styles.previousRound_title}>
        <L10nText tk="PREVIOUS_ROUND" />
      </div>
      <button className={styles.previousRound_button}>
        <Icon icon={show ? Icons.History : Icons.Close} color={'white'}></Icon>
      </button>
    </div>
  );
};
